<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import {getCurrentInstance} from "vue";
import {cn} from '@/shared/lib/utils'
import {computed} from "vue";

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const color = computed(() => findColor(getCurrentInstance()?.parent?.props?.variant as string))

function findColor(variant?: string | null) {
  switch (variant) {
    case 'informative':
      return 'text-blue-700'
    case 'postive':
      return 'text-green-700'
    case 'notice':
      return 'text-yellow-700'
    case 'negative':
      return 'text-red-700'
    default:
      return 'text-slate-850'
  }
}

</script>

<template>
  <div :class="cn('mt-2 text-sm', color, props.class)">
    <slot />
  </div>
</template>
